export default __webpack_public_path__ + "static/image2-a8322c4cfbd5c4dc1f3ddbcec460475b.svg";